// src/lodash-adapter.ts
import clamp from "lodash/clamp";
import cloneDeep from "lodash/cloneDeep";
import debounce from "lodash/debounce";
import get from "lodash/get";
import isBoolean from "lodash/isBoolean";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import isNumber from "lodash/isNumber";
import isPlainObject from "lodash/isPlainObject";
import isString from "lodash/isString";
import isTypedArray from "lodash/isTypedArray";
import merge from "lodash/merge";
import mergeWith from "lodash/mergeWith";
import pull from "lodash/pull";
import throttle from "lodash/throttle";
import uniq from "lodash/uniq";
import upperFirst from "lodash/upperFirst";
import isFunction from "lodash/isFunction";
import isObject from "lodash/isObject";
import isUndefined from "lodash/isUndefined";
import camelCase from "lodash/camelCase";
import uniqueId from "lodash/uniqueId";
var lodashUtil = {
  isNil,
  merge,
  throttle,
  isString,
  debounce,
  pull,
  isTypedArray,
  isPlainObject,
  isNumber,
  isBoolean,
  isEqual,
  cloneDeep,
  uniq,
  clamp,
  upperFirst,
  get,
  mergeWith,
  isFunction,
  isObject,
  isUndefined,
  camelCase,
  uniqueId
};
export {
  lodashUtil
};
